import { LitElement as f, unsafeCSS as y } from "lit";
import { property as t } from "lit/decorators.js";
import h from "../../shared/reset.style.css.js";
import { booleanType as r } from "../../utils/property-types.js";
import c from "./icon-button.style.css.js";
import { template as u } from "./icon-button.template.js";
var m = Object.defineProperty, e = (l, s, p, a) => {
  for (var i = void 0, n = l.length - 1, d; n >= 0; n--)
    (d = l[n]) && (i = d(s, p, i) || i);
  return i && m(s, p, i), i;
};
class o extends f {
  constructor() {
    super(...arguments), this.type = "button", this.variant = "primary", this.size = "md", this.label = "", this.icon = void 0, this.fill = !1, this.disabled = !1, this.hidden = !1, this.disableTabindex = !1, this.ariaLabel = null, this.ariaExpanded = void 0, this.tooltipFixed = !1, this.tooltipInteractive = !1, this.tooltipPosition = "top", this.hideTooltip = !1, this.forceViewport = !1;
  }
  static get styles() {
    return [y(h), y(c)];
  }
  _handleClick() {
    this.dispatchEvent(new CustomEvent("onClick", { bubbles: !0, composed: !0 }));
  }
  focus(s) {
    var i;
    const p = (i = this.shadowRoot) == null ? void 0 : i.querySelector(".dss-icon-button");
    if (!p) return;
    const a = { ...s, focusVisible: !0 };
    p.focus(a);
  }
  render() {
    return u(this);
  }
}
e([
  t({ type: String })
], o.prototype, "type");
e([
  t({ type: String })
], o.prototype, "variant");
e([
  t({ type: String })
], o.prototype, "size");
e([
  t({ type: String })
], o.prototype, "label");
e([
  t({ type: String })
], o.prototype, "icon");
e([
  t(r)
], o.prototype, "fill");
e([
  t(r)
], o.prototype, "disabled");
e([
  t(r)
], o.prototype, "hidden");
e([
  t(r)
], o.prototype, "disableTabindex");
e([
  t({ type: String })
], o.prototype, "ariaLabel");
e([
  t(r)
], o.prototype, "ariaExpanded");
e([
  t(r)
], o.prototype, "tooltipFixed");
e([
  t(r)
], o.prototype, "tooltipInteractive");
e([
  t({ type: String })
], o.prototype, "tooltipPosition");
e([
  t(r)
], o.prototype, "hideTooltip");
e([
  t(r)
], o.prototype, "forceViewport");
export {
  o as IconButton
};
//# sourceMappingURL=icon-button.js.map
